<template>
  <div>
    <public-title showBack v-if="queryCon.none!=1">门店资料</public-title>
    <public-title  v-else></public-title>
    <div class="load-area" v-if="queryCon.type != 4">
      <h4 class="bg-base p-3 text-left">基本信息</h4>
      <base-info @showUserArr="showUserArr = !showUserArr" :confirm='queryCon.confirm'/>
      <h4 class="bg-base p-3 text-left" v-if="StoreBasicInfo.contract_pic&&StoreBasicInfo.contract_pic.length">签约合同</h4>
      <div class="contract-list" v-if="StoreBasicInfo.contract_pic&&StoreBasicInfo.contract_pic.length">
        <div v-for="(m,idx) in StoreBasicInfo.contract_pic.split(',')" :key="idx" class="contract-list-item">
          <a :href="$GFUN.formatImgSrc(m)" target="_blank">文件{{idx+1}}</a>
        </div>
      </div>
      <h4 class="bg-base p-3 text-left" v-show="showUserArr">负责人</h4>
      <user-arr  v-show="showUserArr"/>
      <h4 class="bg-base p-3 text-left mt-3">认证信息</h4>
      <verify-info />
      <h4 class="bg-base p-3 text-left mt-4 mb-3">门店信息</h4>
      <travel-user v-if="storeInfo.type===2" @showItemDetail="showItemDetail"/>
      <hotel-user v-if="$GFUN.isInArray([3,5],storeInfo.type)" @showItemDetail="showItemDetail"/>
      <scenic-user v-if="storeInfo.type == 6" @showItemDetail="showItemDetail"/>
      <brand-user v-if="storeInfo.type == 8" @showItemDetail="showItemDetail"/>
      <!--展示门店的银行卡、发票、房型、外观内景图-->
      <div v-if="showDetailType">
        <h4 class="bg-base p-3  mt-4 mb-3 expand">
          <div>{{detailTypeArr[showDetailType]}}</div>
          <el-button size="mini" @click="expand=!expand">{{expand==true?'收起':'展开'}}<i :class="expand?'el-icon-caret-top':'el-icon-caret-bottom'"></i></el-button>
        </h4>
        <p v-if="itemLists.length<=0" class="mt-4">当前没有数据</p>
        <div  v-if="expand&&itemLists.length>0">
          <div v-if="$GFUN.isInArray(['pic','interiorPic','banner_pic'],showDetailType)">
            <upload-image :existImgs="itemLists" v-if="'pic'==showDetailType"/>
            <upload-image :existImgs="itemLists" v-if="'interiorPic'==showDetailType"/>
            <upload-image :existImgs="itemLists" v-if="'banner_pic'==showDetailType"/>
          </div>
          <div v-else>
            <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
            <div v-for="Itemize in itemLists" :key="Itemize.id">
              <itemize-bankcard :Itemize="Itemize" v-if="showDetailType === 'bankcard'"/>
              <itemize-invoice :Itemize="Itemize" v-if="showDetailType === 'invoice'"/>
              <itemize-room :Itemize="Itemize" v-if="showDetailType === 'roomList'"/>
              <itemize-meet :Itemize="Itemize" v-if="showDetailType === 'meetList'"/>
              <itemize-itinerary :Itemize="Itemize" v-if="showDetailType === 'itineraryList'"/>
              <itemize-restaurant :Itemize="Itemize" v-if="showDetailType === 'restaurantList'"/>
              <activities :Itemize="Itemize" v-if="showDetailType === 'activities'"/>
              <tickets-num :Itemize="Itemize" v-if="showDetailType === 'ticket'" />
              <home-stay-nums :Itemize="Itemize" v-if="showDetailType === 'homestay'" />
            </div>
            <el-pagination background layout="prev, pager, next" class="mt-4"
                    v-if="showDetailType === 'homestay'"
                    :total="StoreDiscountLists.total" :current-page="Number(queryCon.page)"
                    @current-change="v => this.currentPage=v"/>
            <el-pagination background layout="prev, pager, next" class="mt-4"
                      v-if="showDetailType === 'ticket'"
                      :total="StoreTicketList.total" :current-page="Number(queryCon.page)"
                      @current-change="v => this.currentPage1=v"/>
          </div>
        </div>
      </div>
      <h4 class="bg-base p-3 text-left mt-4">用户活跃信息</h4>
      <activity-info />
      <div class="mt-4" v-if="StoreBasicInfo.verify==2&&queryCon.none!=1||StoreBasicInfo.verify==1&&userInfo.type==99&&queryCon.none!=1">
        <el-button type="success" @click="passStore">通过认证</el-button>
        <el-button type="danger" @click="refuseVerify = true">审核拒绝</el-button>
      </div>
    </div>
    <div class="load-area" v-else>
      <guide-base-info />
      <div class="mt-4" v-if="(StoreBasicInfo.verify==2||StoreBasicInfo.verify==1) &&userInfo.type==99&&queryCon.none!=1">
        <el-button type="success" @click="passStore">通过认证</el-button>
        <el-button type="danger" @click="refuseVerify = true">审核拒绝</el-button>
      </div>
    </div>
    <el-dialog :title="queryCon.type != 4 ? '请设置门店对接人' : '设置导游等级及对接人'" :visible.sync="passVerify" center>
      <el-select v-if="queryCon.type != 4" v-model="StoreBasicInfo.person_liable_id" class="w-100" placeholder="请设置门店对接人">
        <el-option v-for="item in staffListArr"
                   :key="item.id"
                   :label="item.truename"
                   :value="item.id" />
      </el-select>
      <div class="w-70 ml-auto mr-auto" v-else>
        <div class="d-center-between mb-3"><left-text leftText="设置导游等级" />
          <el-select v-model="StoreBasicInfo.level" class="w-60" placeholder="设置导游等级">
            <el-option v-for="item in $GVAR.guideLevel"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id" />
          </el-select>
        </div>
        <div class="d-center-between"><left-text leftText="设置导游对接人" />
          <el-select v-model="StoreBasicInfo.person_liable_id" class="w-60" placeholder="设置导游对接人">
            <el-option v-for="item in staffListArr"
                      :key="item.id"
                      :label="item.truename"
                      :value="item.id" />
          </el-select>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="passVerify = false">取 消</el-button>
        <el-button type="primary" @click="verifyControl('1')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择拒绝原因" :visible.sync="refuseVerify" center>
      <el-radio-group v-if="queryCon.type != 4" v-model="refuseValue">
        <el-radio :label="item"  v-for="(item,index) in refuseArr" :key="index" class="mb-2 ml-0 mr-4">{{item}}</el-radio>
      </el-radio-group>
      <p class="d-center-start" v-if="refuseValue==='其他' || queryCon.type == 4">{{ queryCon.type != 4 ? '其他：' : ''}}
        <el-input v-model="verifyRemark" :class="queryCon.type != 4 ? 'w-70' : 'w-100'"/>
      </p>
      <div slot="footer">
        <el-button @click="refuseVerify = false">取 消</el-button>
        <el-button type="primary" @click="verifyControl('0')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {mapGetters,mapMutations,mapActions,mapState} from 'vuex'
  import BaseInfo from './Comps/BaseInfo';
  import HotelUser from './Comps/HotelUser';
  import VerifyInfo from './Comps/VerifyInfo'
  import ActivityInfo from './Comps/ActivityInfo'
  import TravelUser from './Comps/TravelUser'
  import ItemizeBankcard from './Comps/ItemizeBankcard'
  import ItemizeInvoice from './Comps/ItemizeInvoice'
  import ItemizeRoom from './Comps/ItemizeRoom'
  import ItemizeMeet from './Comps/ItemizeMeet'
  import ItemizeItinerary from './Comps/ItemizeItinerary'
  import ItemizeRestaurant from './Comps/ItemizeRestaurant'
  import ScenicUser from './Comps/ScenicUser'
  import BrandUser from './Comps/BrandUser'
  import UserArr from './Comps/UserArr'
  import Activities from './Comps/Activities.vue'
  import TicketsNum from './Comps/TicketsNum.vue'
  import HomeStayNums from './Comps/HomeStayNums.vue'
  import GuideBaseInfo from './Comps/GuideBaseInfo'

  export default {
    name: 'StoreDetail',
    components: {
      UserArr,ScenicUser,BrandUser,ItemizeMeet,ItemizeRoom,ItemizeInvoice,ItemizeBankcard,TravelUser,ItemizeItinerary,
      ActivityInfo,VerifyInfo,HotelUser,BaseInfo,Activities,TicketsNum,HomeStayNums,GuideBaseInfo,ItemizeRestaurant
    },
    computed:{
      ...mapState(['StoreBasicInfo','StoreBankcardList','StoreInvoiceLists','StoreDiscountLists','staffLists','StoreTicketList']),
      ...mapGetters(['storeInfo','userInfo']),
      queryCon() { return this.$route.query },
      titleArr () {
        switch (this.showDetailType) {
          case 'roomList': 
            if (this.queryCon.type == 8) return ['名称 / 类型', '周末价格','非周末价格', '房间数','面积','房间特征','上传照片'];
            else return ['名称 / 类型', '团队价', '散客价', '房间数','面积','房间特征','上传照片'];
          case 'meetList': return ['名称 / 布局', '可容纳人数', '费用', '层高','面积','备注','上传照片'];
          case 'itineraryList': return ['名称', '线路行程时效', '天数', '行程单','价格','状态'];
          case 'restaurantList': return ['名称', '用餐类型', '价格/费用种类', '添加时间','状态'];
          case 'bankcard': return ['所属','企业名称/个人姓名','开户银行','支行名称','银行卡号','备注'];
          case 'invoice': return ['发票类型','公司抬头','税号','收件人','联系方式','添加时间'];
          case 'activities': return ['酒店名称','标题','开始时间','结束时间','申请时间','操作'];
          case 'ticket': 
            if (this.queryCon.type == 8) return ['票种','产品名称','价格','状态','添加时间'];
            else return ['票种','产品名称','价格','状态','操作'];
          case 'homestay': return ['活动名称','活动种类','添加时间','状态','操作']
          default: return [];
        }
      },
      //业务负责人备选项
      staffListArr() {
        let arr = $.extend(true, [], this.StoreBasicInfo.adminList);
        arr.unshift({
          id:0,
          truename:'无'
        })
        return arr;
      },
      //展示的银行卡、发票、房型、会议室等数组信息
      itemLists() {
        switch (this.showDetailType) {
          case 'roomList': return this.room_arr;
          case 'meetList': return this.meeting_arr;
          case 'itineraryList': return this.StoreBasicInfo.itineraryArr.itinerary_list;
          case 'restaurantList': return this.StoreBasicInfo.restaurantArr.restaurant_list;
          case 'bankcard': return this.StoreBankcardList.lists;
          case 'invoice': return this.StoreInvoiceLists.lists;
          case 'banner_pic': return this.StoreBasicInfo.banner_pic.split(',');
          case 'pic': return this.StoreBasicInfo.pic;
          case 'interiorPic':return this.StoreBasicInfo.pic_lobby;
          case 'activities': return this.acts;
          case 'ticket': 
            if (this.queryCon.type == 8) return this.StoreBasicInfo.onsaleArr.onsale_list;
            else return this.StoreTicketList.lists;
          case 'homestay': return this.StoreDiscountLists.lists
          default: return [];
        }
      }
    },
    watch:{
      currentPage() { this.getStoreDiscountLists({store_id:this.queryCon.id,page: this.currentPage}) },
      currentPage1() { this.getStoreTicketLists({page: this.currentPage1}) }
    },
    data() {
      return {
        expand:true,
        refuseVerify:false,
        passVerify:false,
        showUserArr:false,
        room_arr:[],
        meeting_arr:[],
        refuseArr: [
          '单位名称有误',
          '单位地址有误',
          '外观图不正确',
          '内景图不正确',
          '房型信息填写有误',
          '会议室信息填写有误',
          '营业执照信息不正确',
          '其他'
        ],                   //重新认证的理由
        refuseValue:'',
        verifyRemark: '',                   //其他拒绝审核理由
        showDetailType:'',                  //展示的门店信息详情项：银行卡、发票、外管内景图等
        detailTypeArr:{
          'bankcard':'银行卡信息',
          'invoice':'发票信息',
          'roomList':'房型信息',
          'meetList':'会议室信息',
          'itineraryList':'线路行程信息',
          'restaurantList':'餐饮信息',
          'pic':'门店外观图',
          'banner_pic':'轮播大图',
          'interiorPic':'门店内景图',
          'activities':'活动数量',
          'ticket': '门票数量',
          'homestay': '活动数量'
        },
        acts: [],
        tickets: [],
        currentPage: 1,
        currentPage1: 1
      }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryCon.id,type:Number(this.queryCon.type)});
      this.getStoreData();
    },
    beforeDestroy() {
      this.UPDATECURRENTSTORE({storeId:'',type:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE','UPDATEBANKCARDLISTS']),
      ...mapActions(['HotelsMeetLists','HotelsRoomList','getStoreInfo','verifyStore','getWaitVerifyData','getStoreBankcardLists','getStoreDiscountLists','getStoreInvoiceLists','getUserStaffLists','getStoreTicketLists']),
      //获取门店详情
      getStoreData() {
        this.getStoreInfo()
          // is_get_city_name: '1',
          // is_get_contract_name: '1',
          // is_get_order_arr: '1',
          // is_get_store_user_arr: '1',
          // is_get_room_arr: '1',
          // is_get_bankcard_count: '1',
          // is_get_invoice_count: '1',
          // store_id:this.queryCon.id,
      },
      //展示银行卡、发票等详情项
      showItemDetail(type) {
        console.log(type);
        this.showDetailType = type.name||type;
        let lists = this.StoreBasicInfo.bankcard_arr|| [], total = this.StoreBasicInfo.bankcard_arr.length || 0
        switch (type.name||type) {
          case 'bankcard':this.UPDATEBANKCARDLISTS({lists,total}); break;
          case 'invoice':this.getStoreInvoiceLists(); break;
          case 'activities': this.getNums();break;
          case 'roomList':this.room_arr=type.room_arr;break;
          case 'meetList':this.meeting_arr=type.room_arr;break;
          case 'pic':break;
          case 'interiorPic':break;
          case 'ticket': this.getStoreTicketLists();break;
          case 'homestay': this.getStoreDiscountLists({store_id:this.queryCon.id,page: this.currentPage});break;
          default:break;
        }
        console.log(this.room_arr);
      },
      // 获取酒店活动数量的相关list
      async getNums () {
        let res = await this.$axios.post('pc/Admin/adminShowHotelActive',{
          store_id: this.queryCon.id,
        });
        if (res.code === '00000') {
          this.acts = res.data
        }
      },
      /*通过认证门店*/
      passStore() {
        this.passVerify = true;
        this.getUserStaffLists({num:100});
      },
      /*通过认证(flag = 1)/审核拒绝(flag = 0)*/
      verifyControl(flag) {
        let data = {
          store_id: this.queryCon.id,
          confirm:this.queryCon.confirm,
          action_flag: flag==1?1:2,
          display:flag,
          level: this.StoreBasicInfo.level,
          person_liable_id:this.StoreBasicInfo.person_liable_id,
        };
        if (flag === '0') {
          if (!this.refuseValue && this.queryCon.type != 4) {
            this._alert('请填写拒绝理由',null,'error');
            return;
          }
          if ((this.refuseValue === '其他' || this.queryCon.type == 4) && !this.verifyRemark) {
            this._alert('请填写其他理由',null,'error');
            return;
          }
          data.action_remark = (this.refuseValue === '其他' || this.queryCon.type == 4) ? this.verifyRemark : this.refuseValue;
        }
        if (flag === '1' && this.queryCon.type == 4) {
          if (this.StoreBasicInfo.person_liable_id == 0) { this._alert('请选择导游对接人',null,'error'); return }
          if (this.StoreBasicInfo.level == 0) { this._alert('请设置导游等级',null,'error'); return }
        }
        this._confirm('确认操作么？',() => {
          this.verifyStore({
            data,
            successFun:() => {
              this.refuseVerify = false;
              this.passVerify = false;
              this.$router.back();             //返回上一页
              // this.getStoreData();          //更新门店信息
              // this.getWaitVerifyData();     //更新待审核数据
            }
          });
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
.contract-list{
  text-align: left;
  a{
    display: block;
    margin:10px 0;
  }
}
.expand{
  display: flex;
  justify-content: space-between;
}
</style>